import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import { Disease, FunctionalStatus } from "@domain/medical-condition/medical-condition";
import { isPendingPatient, Patient, PatientStatus, PendingPatient } from "@domain/patient/patient";
import { HomeTabNames } from "@ui/pages/home/components/patient-tabs";
import { InvitationCodeSharingMethod } from "@ui/pages/home/pending-patient-dialog/components/pending-patient-created";

const SHARING_METHOD_ANALYTICS_ACTION: Record<InvitationCodeSharingMethod, string> = {
	print: "patientCreatedPrintCode",
	email: "patientCreatedSendEmail",
};
export const sendAnalyticsEventPatientDeleted = (status: PatientStatus): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.PATIENT,
		action: "patientDeleted",
		params: [status === PatientStatus.Pending ? "pending" : "registered"],
	});
};

export const sendAnalyticsEventReinvitePatient = (): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.PATIENT,
		action: "openReinviteWindow",
	});
};

export const sendAnalyticsEventPatientListViewed = (homeTab: HomeTabNames): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.PATIENT,
		action: "viewPatientList",
		params: [homeTab],
	});
};

export const sendAnalyticsEventSharePatientCode = (
	sharingMethod: InvitationCodeSharingMethod,
	newlyInvited: boolean,
	withDetail: boolean,
): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.PATIENT,
		action: SHARING_METHOD_ANALYTICS_ACTION[sharingMethod],
		params: [withDetail ? "withDetail" : "withoutDetail", newlyInvited ? "invite" : "reinvite"],
	});
};
export const sendAnalyticsEventEditPatientDetails = (
	oldPatient: PendingPatient | Patient,
	updatedFields: {
		functionalStatus?: FunctionalStatus;
		disease?: Disease;
	},
): void => {
	analyticsService.trackEvent({
		action: "editPatientDetail",
		category: AnalyticsCategory.PATIENT,
		params: [
			oldPatient.functionalStatus !== updatedFields.functionalStatus ? "functionalStatus" : "",
			!isPendingPatient(oldPatient) && oldPatient.disease !== updatedFields.disease ? "medicalCondition" : "",
			oldPatient.analyticsId,
		],
	});
};
export const sendAnalyticsEventPatientCreated = (analyticsId: string, withDetail: boolean): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.PATIENT,
		action: "patientCreated",
		params: [withDetail ? "withDetail" : "withoutDetail", analyticsId],
	});
};

export const sendAnalyticsEventCreateNewPatient = (): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.PATIENT,
		action: "createNewPatient",
	});
};

export const sendAnalyticsEventJoinExistingPatient = (): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.PATIENT,
		action: "joinExistingPatient",
	});
};

export const sendAnalyticsEventJoinPatientHealthcareTeam = (patientId: string): void => {
	analyticsService.trackEvent({
		category: AnalyticsCategory.PATIENT,
		action: "existingPatientAdded",
		params: [patientId],
	});
};
